import DatabaseBox from './DatabaseBox'
import ListaDatabase from './ListaDatabase'
import './Database.css'
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

function Database({user, assistant}){

    const [updateFlag, setUpdateFlag] = useState(false);
    const [documentList, setDocumentList] = useState([]);

    // Recebendo o Id do assistente a partir do Hub
    const location = useLocation();
    const assistantId = location.state?.assistantId || 'nada'; // Garante que assistantId não seja undefined
    const sessionId = location.state?.sessionId || 'nada';

    // Estado para armazenar o filtro de status
    const [selectedStatus, setSelectedStatus] = useState(''); // Filtro pelo status

    // Estado para armazenar os filtros de busca
    const [filters, setFilters] = useState({
        searchTerm: '',   // Filtro pelo nome
        selectedStatus: '', // Filtro pelo status
        selectedDate: ''  // Filtro pela data
    });

    // Função para forçar atualização
    const triggerUpdate = () => {
        setUpdateFlag(prev => !prev); // Toggling the flag to force re-render in ListaDatabase
    }

    return(
        <main className='corpo'>
            <DatabaseBox  
            classeCSS="database-box" 
            triggerUpdate={triggerUpdate}
            user={user}
            setFilters={setFilters}
            setSelectedStatus={setSelectedStatus}
            assistant={assistant}
            assistantId={assistantId}
            sessionId={sessionId}
            documentList={documentList} 
            />
            <ListaDatabase 
            classeCSS="lista-database" 
            updateFlag={updateFlag}
            triggerUpdate={triggerUpdate}
            documentList={documentList} 
            setDocumentList={setDocumentList}
            user={user}
            filters={filters}
            selectedStatus={selectedStatus}
            assistant={assistant}
            assistantId={assistantId}
            sessionId={sessionId}
            />
        </main>
    )
}

export default Database